import connectAsync from '../../utils/connectAsync';
import { fetchMeWithFavorites } from '../../actions/me';
import FavoritesRoute from './FavoritesRoute';

export default connectAsync([fetchMeWithFavorites])(FavoritesRoute);
